var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 6.85479L17.1421 11.0975L7.24264 20.997H3V16.7543L12.8995 6.85479ZM14.3137 5.44058L16.435 3.31926C16.8256 2.92874 17.4587 2.92874 17.8492 3.31926L20.6777 6.14769C21.0682 6.53821 21.0682 7.17138 20.6777 7.5619L18.5563 9.68322L14.3137 5.44058Z",
    fill: "#071E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.94cfa472fd86a0be102f07a2e81cbcfe.svg";
export { ForwardRef as ReactComponent };